import { ELocale } from '@/i18n/localeEnum';
import { Routes } from '@/routes';
import { getLocale } from '@/i18n/locale';

/**
 * Returns the correct logo href URL for summer overview depending on locale.
 * @param isOnSummerOverview - whether the user is on resort/summer-overview
 */
export function getSummerLogoHrefUrl(isOnSummerOverview: boolean): string {
  if (!isOnSummerOverview) return Routes.root;
  switch (getLocale()) {
    case ELocale.EN_US:
      return 'https://www.mountaingetaway.co/';
    case ELocale.EN_GB:
      return 'https://www.mountainnews.co.uk/';
    case ELocale.DE_DE:
      return 'https://www.mountainnews.de/';
    case ELocale.FR_FR:
      return 'https://www.mountainnews.fr/';
    case ELocale.IT_IT:
      return 'https://www.mountainnews.it/';
    case ELocale.PL_PL:
      return 'https://www.mountainnews.pl/';
    default:
      return Routes.root;
  }
}
